import { createNav, bindNav } from "./components/Nav.js";
import { createFooter } from "./sections/Footer.js";
import { createLoginHeroSection } from "./sections/login/LoginHero.js";
import { createLoginFormSection } from "./sections/login/LoginForm.js";
import { getLoginPage, loginRoute } from "../config/loginContent.js";

export function mountLoginPage(root) {
  const pageContent = getLoginPage();

  const canvasLayer = document.createElement("div");
  canvasLayer.className = "canvas-layer";
  canvasLayer.innerHTML = `<canvas id="canvas" aria-hidden="true"></canvas>`;

  const contentLayer = document.createElement("div");
  contentLayer.className = "content-layer content-layer--login";

  const nav = createNav();

  contentLayer.append(
    nav,
    createLoginHeroSection(),
    createLoginFormSection(),
    createFooter()
  );

  root.append(canvasLayer, contentLayer);

  const updateNavActive = bindNav(nav, {
    page: "login",
    sectionMap: {
      hero: loginRoute("hero"),
      login: loginRoute("login"),
    },
  });

  return {
    canvas: canvasLayer.querySelector("#canvas"),
    updateNavActive,
    documentTitle: pageContent.documentTitle,
    sections: {
      hero: contentLayer.querySelector("#hero"),
      login: contentLayer.querySelector("#login"),
    },
  };
}
